module.exports = __webpack_public_path__ + "static/media/FR.43fad009.svg";